import image from '../assets/images/client-logos/client_logo_1.png';
import image1 from '../assets/images/client-logos/client_logo_2.png';
import image2 from '../assets/images/client-logos/client_logo_3.png';
import image3 from '../assets/images/client-logos/client_logo_4.png';
import image4 from '../assets/images/client-logos/client_logo_5.png';
import image5 from '../assets/images/client-logos/client_logo_6.png';
import image6 from '../assets/images/client-logos/client_logo_7.png';
import image7 from '../assets/images/client-logos/client_logo_8.png';
import image8 from '../assets/images/client-logos/client_logo_9.png';
import image9 from '../assets/images/client-logos/client_logo_10.png';
import image10 from '../assets/images/client-logos/client_logo_11.png';
import image11 from '../assets/images/client-logos/client_logo_12.png';
import image12 from '../assets/images/client-logos/client_logo_13.png';
import image13 from '../assets/images/client-logos/client_logo_14.png';
import image14 from '../assets/images/client-logos/client_logo_15.png';
import image15 from '../assets/images/client-logos/client_logo_16.png';
import image16 from '../assets/images/client-logos/client_logo_17.png';
import image17 from '../assets/images/client-logos/client_logo_18.png';
import image18 from '../assets/images/client-logos/client_logo_19.png';

const clients = [
    {
        url: '#',
        image: {
            src: image,
            alt: 'client image',
        },
    },
    {
        url: '#',
        image: {
            src: image1,
            alt: 'client image',
        },
    },
    {
        url: '#',
        image: {
            src: image2,
            alt: 'client image',
        },
    },
    {
        url: '#',
        image: {
            src: image3,
            alt: 'client image',
        },
    },
    {
        url: '#',
        image: {
            src: image4,
            alt: 'client image',
        },
    },
    {
        url: '#',
        image: {
            src: image5,
            alt: 'client image',
        },
    },
      {
        url: '#',
        image: {
            src: image6,
            alt: 'client image',
        },
    },
      {
        url: '#',
        image: {
            src: image7,
            alt: 'client image',
        },
    },
      {
        url: '#',
        image: {
            src: image8,
            alt: 'client image',
        },
    },
      {
        url: '#',
        image: {
            src: image9,
            alt: 'client image',
        },
    },
          {
        url: '#',
        image: {
            src: image10,
            alt: 'client image',
        },
    },
          {
        url: '#',
        image: {
            src: image11,
            alt: 'client image',
        },
    },
          {
        url: '#',
        image: {
            src: image12,
            alt: 'client image',
        },
    },
    {
        url: '#',
        image: {
            src: image13,
            alt: 'client image',
        },
    },
    {
        url: '#',
        image: {
            src: image14,
            alt: 'client image',
        },
    },
    {
        url: '#',
        image: {
            src: image15,
            alt: 'client image',
        },
    },
        {
        url: '#',
        image: {
            src: image16,
            alt: 'client image',
        },
    },
    {
        url: '#',
        image: {
            src: image17,
            alt: 'client image',
        },
    },
        {
        url: '#',
        image: {
            src: image18,
            alt: 'client image',
        },
    },
];

export default clients;
